module.exports = __webpack_public_path__ + "img/1.dbae8e90.jpg";